<template>
  <div style="height: 310px" ref="chart"></div>
</template>

<script>
export default {
  props: {
    seriesData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      myCharts: null,
      chartData: [
        // {
        //   value: 11,
        //   name: "白领/一般职员",
        //   rate: "4.17%",
        // },
        // {
        //   value: 22,
        //   name: "金融从业者",
        //   rate: "1.17%",
        // },
        // {
        //   value: 33,
        //   name: "老师",
        //   rate: "6.17%",
        // },
        // {
        //   value: 44,
        //   name: "学生",
        //   rate: "22.17%",
        // },
        // {
        //   value: 55,
        //   name: "公务员",
        //   rate: "6.17%",
        // },
        // {
        //   value: 66,
        //   name: "工人",
        //   rate: "2.17%",
        // },
        // {
        //   value: 77,
        //   name: "农民",
        //   rate: "0.00%",
        // },
        // {
        //   value: 88,
        //   name: "医务人员",
        //   rate: "2.08%",
        // },
        // {
        //   value: 99,
        //   name: "未识别",
        //   rate: "14.57%",
        // },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.chartData = this.seriesData;
      if (this.chartData.length > 0) {
        this.initChart();
        window.addEventListener("resize", () => {
          this.myCharts.resize();
        });
      }
    });
  },
  methods: {
    initChart() {
      this.myCharts = this.$echarts.init(this.$refs.chart);
      this.setOptions(this.chartData);
    },
    setOptions(data) {
      let options = {
        title: {
          show: false,
        },
        tooltip: {
          trigger: "axis",
          formatter: "{b} <br/>{c}%",
          axisPointer: {
            type: "shadow",
          },
        },
        color: ["#7e86ec"],
        legend: {
          show: false,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          axisLabel: {
            formatter: (value, index) => {
              return value + "%";
            },
          },
        },
        yAxis: {
          type: "category",
          data: this.chartData.map((v) => v.name),
        },
        series: [
          {
            type: "bar",
            data: data.map((v) => {
              if (v.rate && v.rate.split("%") && v.rate.split("%")[0]) {
                return Number(v.rate.split("%")[0]);
              }
            }),
            label: {
              show: true,
              formatter: (params) => {
                return this.chartData[params.dataIndex].rate;
              },
              position: "right",
            },
          },
        ],
      };
      this.myCharts.setOption(options);
    },
  },
};
</script>

<style scoped lang="scss"></style>
